import { Fragment } from 'preact'

import type { CookieConsentTranslator } from '#src/assets/lib/i18n.ts'
import { Heading } from '#src/assets/ui/shared/components/Heading.tsx'
import { Paragraph } from '#src/assets/ui/shared/components/Paragraph.tsx'
import type { SiteConfig } from '#src/models/site-configs/siteConfigs.ts'

export function PolicySectionSettings({
  t,
  siteConfig,
}: {
  t: CookieConsentTranslator
  siteConfig: SiteConfig
}) {
  return (
    <Fragment>
      <Heading level={3}>{t('policySettingsTitle')}</Heading>
      <Paragraph>{t('policySettingsBody')}</Paragraph>
      <Paragraph>
        {t('policyChangeSettingsParagraph', {
          cookiePolicyUrl: siteConfig.cookiePolicyUrl,
        })}
      </Paragraph>
    </Fragment>
  )
}
